var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { memoize } from "lodash";
import * as Long from "long";
import { utilBalancing } from "../utils/utilBalancing";
export var selectBalancingResources = function () { return utilBalancing.getBalancing().Resources; };
export var selectBalancingResource = memoize(function (typeId) { return selectBalancingResources().get(typeId); });
// TODO: consider what to do with this. (duplicating selectBalancingResource.
export var selectResourceInfo = memoize(function (resourceId) {
    var resource = selectBalancingResource(resourceId);
    if (!resource) {
        throw new Error("Resource " + resourceId + " not found!");
    }
    return resource;
});
export var selectResourceAmountInfo = function (resourceId, amount) {
    var resource = selectResourceInfo(resourceId);
    return __assign({}, resource, { amount: Long.fromValue(amount) });
};
export var selectStandardStageResources = memoize(function (stage) {
    var standard = stage.standard;
    return standard
        ? standard.cost.map(function (cost) {
            var resourceId = cost.resourceId, amount = cost.amount;
            return selectResourceAmountInfo(resourceId, amount);
        })
        : undefined;
});
export var balancingResourcesMemoizedFunctions = [
    selectBalancingResources,
    selectBalancingResource,
    selectResourceInfo,
    selectStandardStageResources,
];



//////////////////
// WEBPACK FOOTER
// ./src/balancingSelectors/selectBalancingResources.ts
// module id = 28
// module chunks = 3